export class LoanSummary {
  borrowerName: string;
  city: string;
  streetAddress: string;
  loanStatus: string;
  loanStatusAlias: string;
  loanNumber: string;
  channel: string;
  subStatusName: string;
}
